// FileSystem.js

class FileSystem {
  constructor() {
    this.root = {};
    this.load();
  }

  format() {
    this.root = {
      'sys': {
        type: 'dir',
        content: {
          'startup.conf': {
            type: 'file',
            content: 'help'
          },
          'help.txt': {
            type: 'file',
            content: '    available commands:\n\tls     - list directory\n\tpwd    - print directory\n\tcd     - change directory\n\tcat    - print file\n\trm     - remove file\n\ttouch  - create file\n\topen   - open link\n\tsh     - execute file\n\trestart- restart terminal\n\treset  - reset file system\n\tclear  - clear screen'
          },
          'alias.conf': {
            type: 'file',
            content: 'help: cat /sys/help.txt\nalias: cat /sys/alias.conf'
          },
          'hist.log': {
            type: 'file',
            content: ''
          }
        }
      },
      'projects': {
        type: 'dir',
        content: {
          'test': {
            type: 'dir',
            content: {
              'text.txt': {
                type: 'file',
                content: 'hello\n\tthere'
              },
              'movie.mp4': {
                type: 'file',
                content: '0xFF'
              },
              'page.html': {
                type: 'file',
                content: '<script src="http://www.google.com/robots.txt/"></script>'
              },
              'link': {
                type: 'link',
                content: 'http://www.google.com/'
              },
              'bitcoins': {
                type: 'dir',
                content: {
                  'donttouch.bit': {
                    type: 'file',
                    content: '5B'
                  }
                }
              }
            }
          },
          'didrik.tech': {
            type: 'dir',
            content: {
              'flappy': {
                type: 'link',
                content: 'https://didrik.tech/flappy'
              },
              'github': {
                type: 'link',
                content: 'https://github.com/Malaxiz'
              }
            }
          },
        }
      }
    };

    return this;
  }

  save() {
    window.localStorage.setItem('fs', JSON.stringify(this.root));
    return this;
  }

  load() {
    let local = window.localStorage.getItem('fs');
    if(!local) {
      this.format();
      return;
    }

    try {
      this.root = JSON.parse(local);
    } catch(e) {
      this.format();
    }

    return this;
  }

  write(dir, content) {
    let status = 'notfound';
    let file = this.ls(dir);
    if(file.status === 'isfile' || file.status === 'islink') {
      let fileName = dir.pop();

      this.ls(dir).content[fileName] = {
        type: file.type,
        content: content
      };

      status = 'success';
    } else if(file.status === 'isdir') {
      status = 'notfound';
    } else {
      status = 'isdir';
    }

    return { status };
  }

  ls(dir) {
    let current = this.root;

    for(let i in dir) {
      if(!current[dir[i]]) {
        return { status: 'notfound' };
      }
      if(current[dir[i]].type !== 'dir') {
        return { status: 'is' + current[dir[i]].type, content: current[dir[i]].content, type: current[dir[i]].type }; // isfile, islink
      }

      current = current[dir[i]].content;
    }

    return { status: 'isdir', content: current };
  }
}

export default FileSystem;


// WEBPACK FOOTER //
// ./src/FileSystem.js